var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 5503 2700"
    },
    xmlSpace: "preserve",
    viewBox: "1757.4 681.7 2080.2 1336.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#204ACE;}\n\t.st1{fill:#F64227;}\n\t.st2{fill:#F9910A;}\n\t.st3{opacity:7.000000e-02;fill:#F4F9F9;}\n\t.st4{opacity:0;fill:#F4F9F9;}\n\t.st5{opacity:0.7;fill:#F4F9F9;}\n\t.st6{opacity:0.31;fill:#F4F9F9;}\n\t.st7{opacity:0.61;fill:#F4F9F9;}\n\t.st8{opacity:0.41;fill:#F4F9F9;}\n\t.st9{opacity:0.38;fill:#F4F9F9;}\n\t.st10{opacity:0.62;fill:#F4F9F9;}\n\t.st11{opacity:0.88;fill:#F4F9F9;}\n\t.st12{opacity:0.36;fill:#F4F9F9;}\n\t.st13{opacity:0.76;fill:#F4F9F9;}\n\t.st14{opacity:0.35;fill:#F4F9F9;}\n\t.st15{opacity:0.11;fill:#F4F9F9;}\n\t.st16{opacity:3.000000e-02;fill:#F4F9F9;}\n\t.st17{opacity:0.52;fill:#F4F9F9;}\n\t.st18{opacity:0.16;fill:#F4F9F9;}\n\t.st19{fill:#8298AD;}\n\t.st20{fill:#F49313;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2351.7,1369.7 2351.7,1369.7 2251.8,1541.7 2251.8,1541.7 2451.7,1541.7 2451.7,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2751.5,1369.7 2751.5,1369.7 2651.6,1541.7 2651.6,1541.7 2851.4,1541.7 2851.4,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2551.6,1369.7 2551.6,1369.7 2451.7,1541.7 2451.7,1541.7 2651.6,1541.7 2651.6,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2951.4,1369.7 2851.4,1541.7 2851.4,1541.7 3051.3,1541.7 3051.3,1541.7 2951.4,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3051.3,1541.7 3151.3,1369.7 2951.4,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3051.3,1197.7 2951.4,1369.7 2951.4,1369.7 3151.3,1369.7 3151.3,1369.7 3051.3,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2651.6,853.7 2851.4,853.7 2851.4,853.7 2751.5,681.7 2751.5,681.7 2651.6,853.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2851.4,1541.7 2951.4,1369.7 2751.5,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2651.6,1541.7 2751.5,1369.7 2551.6,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2451.7,1541.7 2551.6,1369.7 2351.7,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2451.7,1197.7 2451.7,1197.7 2351.7,1369.7 2351.7,1369.7 2551.6,1369.7 2551.6,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2851.4,1197.7 2751.5,1369.7 2751.5,1369.7 2951.4,1369.7 2951.4,1369.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2951.4,1369.7 3051.3,1197.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2651.6,1197.7 2651.6,1197.7 2551.6,1369.7 2551.6,1369.7 2751.5,1369.7 2751.5,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "2851.4,1197.7 2851.4,1197.7 3051.3,1197.7 3051.3,1197.7 2951.4,1025.7 2951.4,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2551.6,1025.7 2751.5,1025.7 2751.5,1025.7 2651.6,853.7 2651.6,853.7 2551.6,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2851.4,853.7 2651.6,853.7 2751.5,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2751.5,1025.7 2951.4,1025.7 2951.4,1025.7 2851.4,853.7 2851.4,853.7 2751.5,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2551.6,1369.7 2651.6,1197.7 2451.7,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2751.5,1369.7 2851.4,1197.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2951.4,1025.7 2751.5,1025.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2451.7,1197.7 2651.6,1197.7 2651.6,1197.7 2551.6,1025.7 2551.6,1025.7 2451.7,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2651.6,1197.7 2851.4,1197.7 2851.4,1197.7 2751.5,1025.7 2751.5,1025.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "2751.5,1025.7 2551.6,1025.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3151.3,1369.7 3051.3,1541.7 3051.3,1541.7 3251.2,1541.7 3251.2,1541.7 3151.3,1369.7    "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2351.7,1369.7 2351.7,1369.7 2251.8,1541.7 2251.8,1541.7 2451.7,1541.7 2451.7,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2751.5,1369.7 2751.5,1369.7 2651.6,1541.7 2651.6,1541.7 2851.4,1541.7 2851.4,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2551.6,1369.7 2551.6,1369.7 2451.7,1541.7 2451.7,1541.7 2651.6,1541.7 2651.6,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2951.4,1369.7 2851.4,1541.7 2851.4,1541.7 3051.3,1541.7 3051.3,1541.7 2951.4,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "3051.3,1541.7 3151.3,1369.7 2951.4,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3051.3,1197.7 2951.4,1369.7 2951.4,1369.7 3151.3,1369.7 3151.3,1369.7 3051.3,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "2651.6,853.7 2851.4,853.7 2851.4,853.7 2751.5,681.7 2751.5,681.7 2651.6,853.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2851.4,1541.7 2951.4,1369.7 2751.5,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2651.6,1541.7 2751.5,1369.7 2551.6,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2451.7,1541.7 2551.6,1369.7 2351.7,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "2451.7,1197.7 2451.7,1197.7 2351.7,1369.7 2351.7,1369.7 2551.6,1369.7 2551.6,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "2851.4,1197.7 2751.5,1369.7 2751.5,1369.7 2951.4,1369.7 2951.4,1369.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "2951.4,1369.7 3051.3,1197.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "2651.6,1197.7 2651.6,1197.7 2551.6,1369.7 2551.6,1369.7 2751.5,1369.7 2751.5,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2851.4,1197.7 2851.4,1197.7 3051.3,1197.7 3051.3,1197.7 2951.4,1025.7 2951.4,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "2551.6,1025.7 2751.5,1025.7 2751.5,1025.7 2651.6,853.7 2651.6,853.7 2551.6,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "2851.4,853.7 2651.6,853.7 2751.5,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2751.5,1025.7 2951.4,1025.7 2951.4,1025.7 2851.4,853.7 2851.4,853.7 2751.5,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "2551.6,1369.7 2651.6,1197.7 2451.7,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2751.5,1369.7 2851.4,1197.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "2951.4,1025.7 2751.5,1025.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "2451.7,1197.7 2651.6,1197.7 2651.6,1197.7 2551.6,1025.7 2551.6,1025.7 2451.7,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2651.6,1197.7 2851.4,1197.7 2851.4,1197.7 2751.5,1025.7 2751.5,1025.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "2751.5,1025.7 2551.6,1025.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "3151.3,1369.7 3051.3,1541.7 3051.3,1541.7 3251.2,1541.7 3251.2,1541.7 3151.3,1369.7    "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2351.7,1369.7 2351.7,1369.7 2251.8,1541.7 2251.8,1541.7 2451.7,1541.7 2451.7,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2751.5,1369.7 2751.5,1369.7 2651.6,1541.7 2651.6,1541.7 2851.4,1541.7 2851.4,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2551.6,1369.7 2551.6,1369.7 2451.7,1541.7 2451.7,1541.7 2651.6,1541.7 2651.6,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2951.4,1369.7 2851.4,1541.7 2851.4,1541.7 3051.3,1541.7 3051.3,1541.7 2951.4,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "3051.3,1541.7 3151.3,1369.7 2951.4,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3051.3,1197.7 2951.4,1369.7 2951.4,1369.7 3151.3,1369.7 3151.3,1369.7 3051.3,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "2651.6,853.7 2851.4,853.7 2851.4,853.7 2751.5,681.7 2751.5,681.7 2651.6,853.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2851.4,1541.7 2951.4,1369.7 2751.5,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2651.6,1541.7 2751.5,1369.7 2551.6,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2451.7,1541.7 2551.6,1369.7 2351.7,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "2451.7,1197.7 2451.7,1197.7 2351.7,1369.7 2351.7,1369.7 2551.6,1369.7 2551.6,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "2851.4,1197.7 2751.5,1369.7 2751.5,1369.7 2951.4,1369.7 2951.4,1369.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "2951.4,1369.7 3051.3,1197.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "2651.6,1197.7 2651.6,1197.7 2551.6,1369.7 2551.6,1369.7 2751.5,1369.7 2751.5,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2851.4,1197.7 2851.4,1197.7 3051.3,1197.7 3051.3,1197.7 2951.4,1025.7 2951.4,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "2551.6,1025.7 2751.5,1025.7 2751.5,1025.7 2651.6,853.7 2651.6,853.7 2551.6,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "2851.4,853.7 2651.6,853.7 2751.5,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2751.5,1025.7 2951.4,1025.7 2951.4,1025.7 2851.4,853.7 2851.4,853.7 2751.5,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "2551.6,1369.7 2651.6,1197.7 2451.7,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2751.5,1369.7 2851.4,1197.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "2951.4,1025.7 2751.5,1025.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "2451.7,1197.7 2651.6,1197.7 2651.6,1197.7 2551.6,1025.7 2551.6,1025.7 2451.7,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2651.6,1197.7 2851.4,1197.7 2851.4,1197.7 2751.5,1025.7 2751.5,1025.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "2751.5,1025.7 2551.6,1025.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "3151.3,1369.7 3051.3,1541.7 3051.3,1541.7 3251.2,1541.7 3251.2,1541.7 3151.3,1369.7    "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2351.7,1369.7 2351.7,1369.7 2251.8,1541.7 2251.8,1541.7 2451.7,1541.7 2451.7,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2751.5,1369.7 2751.5,1369.7 2651.6,1541.7 2651.6,1541.7 2851.4,1541.7 2851.4,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2551.6,1369.7 2551.6,1369.7 2451.7,1541.7 2451.7,1541.7 2651.6,1541.7 2651.6,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2951.4,1369.7 2851.4,1541.7 2851.4,1541.7 3051.3,1541.7 3051.3,1541.7 2951.4,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "3051.3,1541.7 3151.3,1369.7 2951.4,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3051.3,1197.7 2951.4,1369.7 2951.4,1369.7 3151.3,1369.7 3151.3,1369.7 3051.3,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "2651.6,853.7 2851.4,853.7 2851.4,853.7 2751.5,681.7 2751.5,681.7 2651.6,853.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2851.4,1541.7 2951.4,1369.7 2751.5,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2651.6,1541.7 2751.5,1369.7 2551.6,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2451.7,1541.7 2551.6,1369.7 2351.7,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "2451.7,1197.7 2451.7,1197.7 2351.7,1369.7 2351.7,1369.7 2551.6,1369.7 2551.6,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "2851.4,1197.7 2751.5,1369.7 2751.5,1369.7 2951.4,1369.7 2951.4,1369.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "2951.4,1369.7 3051.3,1197.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "2651.6,1197.7 2651.6,1197.7 2551.6,1369.7 2551.6,1369.7 2751.5,1369.7 2751.5,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2851.4,1197.7 2851.4,1197.7 3051.3,1197.7 3051.3,1197.7 2951.4,1025.7 2951.4,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "2551.6,1025.7 2751.5,1025.7 2751.5,1025.7 2651.6,853.7 2651.6,853.7 2551.6,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "2851.4,853.7 2651.6,853.7 2751.5,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2751.5,1025.7 2951.4,1025.7 2951.4,1025.7 2851.4,853.7 2851.4,853.7 2751.5,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "2551.6,1369.7 2651.6,1197.7 2451.7,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2751.5,1369.7 2851.4,1197.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "2951.4,1025.7 2751.5,1025.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "2451.7,1197.7 2651.6,1197.7 2651.6,1197.7 2551.6,1025.7 2551.6,1025.7 2451.7,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2651.6,1197.7 2851.4,1197.7 2851.4,1197.7 2751.5,1025.7 2751.5,1025.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "2751.5,1025.7 2551.6,1025.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "3151.3,1369.7 3051.3,1541.7 3051.3,1541.7 3251.2,1541.7 3251.2,1541.7 3151.3,1369.7    "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2351.7,1369.7 2351.7,1369.7 2251.8,1541.7 2251.8,1541.7 2451.7,1541.7 2451.7,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2751.5,1369.7 2751.5,1369.7 2651.6,1541.7 2651.6,1541.7 2851.4,1541.7 2851.4,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2551.6,1369.7 2551.6,1369.7 2451.7,1541.7 2451.7,1541.7 2651.6,1541.7 2651.6,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2951.4,1369.7 2851.4,1541.7 2851.4,1541.7 3051.3,1541.7 3051.3,1541.7 2951.4,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "3051.3,1541.7 3151.3,1369.7 2951.4,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3051.3,1197.7 2951.4,1369.7 2951.4,1369.7 3151.3,1369.7 3151.3,1369.7 3051.3,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "2651.6,853.7 2851.4,853.7 2851.4,853.7 2751.5,681.7 2751.5,681.7 2651.6,853.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2851.4,1541.7 2951.4,1369.7 2751.5,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2651.6,1541.7 2751.5,1369.7 2551.6,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2451.7,1541.7 2551.6,1369.7 2351.7,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "2451.7,1197.7 2451.7,1197.7 2351.7,1369.7 2351.7,1369.7 2551.6,1369.7 2551.6,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "2851.4,1197.7 2751.5,1369.7 2751.5,1369.7 2951.4,1369.7 2951.4,1369.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "2951.4,1369.7 3051.3,1197.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "2651.6,1197.7 2651.6,1197.7 2551.6,1369.7 2551.6,1369.7 2751.5,1369.7 2751.5,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2851.4,1197.7 2851.4,1197.7 3051.3,1197.7 3051.3,1197.7 2951.4,1025.7 2951.4,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "2551.6,1025.7 2751.5,1025.7 2751.5,1025.7 2651.6,853.7 2651.6,853.7 2551.6,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "2851.4,853.7 2651.6,853.7 2751.5,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2751.5,1025.7 2951.4,1025.7 2951.4,1025.7 2851.4,853.7 2851.4,853.7 2751.5,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "2551.6,1369.7 2651.6,1197.7 2451.7,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2751.5,1369.7 2851.4,1197.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "2951.4,1025.7 2751.5,1025.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "2451.7,1197.7 2651.6,1197.7 2651.6,1197.7 2551.6,1025.7 2551.6,1025.7 2451.7,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2651.6,1197.7 2851.4,1197.7 2851.4,1197.7 2751.5,1025.7 2751.5,1025.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "2751.5,1025.7 2551.6,1025.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "3151.3,1369.7 3051.3,1541.7 3051.3,1541.7 3251.2,1541.7 3251.2,1541.7 3151.3,1369.7    "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2351.7,1369.7 2351.7,1369.7 2251.8,1541.7 2251.8,1541.7 2451.7,1541.7 2451.7,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2751.5,1369.7 2751.5,1369.7 2651.6,1541.7 2651.6,1541.7 2851.4,1541.7 2851.4,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2551.6,1369.7 2551.6,1369.7 2451.7,1541.7 2451.7,1541.7 2651.6,1541.7 2651.6,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2951.4,1369.7 2851.4,1541.7 2851.4,1541.7 3051.3,1541.7 3051.3,1541.7 2951.4,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "3051.3,1541.7 3151.3,1369.7 2951.4,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3051.3,1197.7 2951.4,1369.7 2951.4,1369.7 3151.3,1369.7 3151.3,1369.7 3051.3,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "2651.6,853.7 2851.4,853.7 2851.4,853.7 2751.5,681.7 2751.5,681.7 2651.6,853.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2851.4,1541.7 2951.4,1369.7 2751.5,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2651.6,1541.7 2751.5,1369.7 2551.6,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2451.7,1541.7 2551.6,1369.7 2351.7,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "2451.7,1197.7 2451.7,1197.7 2351.7,1369.7 2351.7,1369.7 2551.6,1369.7 2551.6,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "2851.4,1197.7 2751.5,1369.7 2751.5,1369.7 2951.4,1369.7 2951.4,1369.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "2951.4,1369.7 3051.3,1197.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "2651.6,1197.7 2651.6,1197.7 2551.6,1369.7 2551.6,1369.7 2751.5,1369.7 2751.5,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2851.4,1197.7 2851.4,1197.7 3051.3,1197.7 3051.3,1197.7 2951.4,1025.7 2951.4,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "2551.6,1025.7 2751.5,1025.7 2751.5,1025.7 2651.6,853.7 2651.6,853.7 2551.6,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "2851.4,853.7 2651.6,853.7 2751.5,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2751.5,1025.7 2951.4,1025.7 2951.4,1025.7 2851.4,853.7 2851.4,853.7 2751.5,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "2551.6,1369.7 2651.6,1197.7 2451.7,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2751.5,1369.7 2851.4,1197.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "2951.4,1025.7 2751.5,1025.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "2451.7,1197.7 2651.6,1197.7 2651.6,1197.7 2551.6,1025.7 2551.6,1025.7 2451.7,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2651.6,1197.7 2851.4,1197.7 2851.4,1197.7 2751.5,1025.7 2751.5,1025.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "2751.5,1025.7 2551.6,1025.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "3151.3,1369.7 3051.3,1541.7 3051.3,1541.7 3251.2,1541.7 3251.2,1541.7 3151.3,1369.7    "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2351.7,1369.7 2351.7,1369.7 2251.8,1541.7 2251.8,1541.7 2451.7,1541.7 2451.7,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2751.5,1369.7 2751.5,1369.7 2651.6,1541.7 2651.6,1541.7 2851.4,1541.7 2851.4,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2551.6,1369.7 2551.6,1369.7 2451.7,1541.7 2451.7,1541.7 2651.6,1541.7 2651.6,1541.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2951.4,1369.7 2851.4,1541.7 2851.4,1541.7 3051.3,1541.7 3051.3,1541.7 2951.4,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "3051.3,1541.7 3151.3,1369.7 2951.4,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "3051.3,1197.7 2951.4,1369.7 2951.4,1369.7 3151.3,1369.7 3151.3,1369.7 3051.3,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "2651.6,853.7 2851.4,853.7 2851.4,853.7 2751.5,681.7 2751.5,681.7 2651.6,853.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2851.4,1541.7 2951.4,1369.7 2751.5,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2651.6,1541.7 2751.5,1369.7 2551.6,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2451.7,1541.7 2551.6,1369.7 2351.7,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "2451.7,1197.7 2451.7,1197.7 2351.7,1369.7 2351.7,1369.7 2551.6,1369.7 2551.6,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "2851.4,1197.7 2751.5,1369.7 2751.5,1369.7 2951.4,1369.7 2951.4,1369.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "2951.4,1369.7 3051.3,1197.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "2651.6,1197.7 2651.6,1197.7 2551.6,1369.7 2551.6,1369.7 2751.5,1369.7 2751.5,1369.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "2851.4,1197.7 2851.4,1197.7 3051.3,1197.7 3051.3,1197.7 2951.4,1025.7 2951.4,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "2551.6,1025.7 2751.5,1025.7 2751.5,1025.7 2651.6,853.7 2651.6,853.7 2551.6,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "2851.4,853.7 2651.6,853.7 2751.5,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2751.5,1025.7 2951.4,1025.7 2951.4,1025.7 2851.4,853.7 2851.4,853.7 2751.5,1025.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "2551.6,1369.7 2651.6,1197.7 2451.7,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2751.5,1369.7 2851.4,1197.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "2951.4,1025.7 2751.5,1025.7 2851.4,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "2451.7,1197.7 2651.6,1197.7 2651.6,1197.7 2551.6,1025.7 2551.6,1025.7 2451.7,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "2651.6,1197.7 2851.4,1197.7 2851.4,1197.7 2751.5,1025.7 2751.5,1025.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "2751.5,1025.7 2551.6,1025.7 2651.6,1197.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "3151.3,1369.7 3051.3,1541.7 3051.3,1541.7 3251.2,1541.7 3251.2,1541.7 3151.3,1369.7    "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M1804.4,1757.9v173.8h-47v-218.2h44.2L1804.4,1757.9z M1796.7,1814.8h-15.9c-0.3-15.2,1.1-29.2,4.1-41.9     c3-12.8,7.6-23.9,13.7-33.5c6.1-9.5,13.8-16.9,23.2-22.1c9.3-5.2,20.2-7.8,32.6-7.8c8.1,0,15.6,1.4,22.5,4.3     c6.9,2.9,13,7.4,18.1,13.6c5.2,6.2,9.1,14.1,11.9,23.8c2.8,9.7,4.1,21.4,4.1,35.1v145.4h-46.8v-141c0-10.5-1.2-18.7-3.5-24.6     c-2.4-5.9-5.7-10.2-10.2-12.8c-4.4-2.6-9.8-3.9-16.1-3.9c-6.9,0-12.7,1.7-17.5,5.1c-4.8,3.4-8.7,8.1-11.7,14.1     c-3,6-5.1,12.9-6.6,20.8C1797.2,1797.4,1796.6,1805.8,1796.7,1814.8z M1908.2,1802.3l-22,5c-0.3-13.2,1.1-25.7,4-37.6     c3-11.9,7.4-22.3,13.4-31.3c6-8.9,13.5-16,22.6-21.2c9.1-5.2,19.5-7.8,31.4-7.8c9.5,0,18,1.5,25.4,4.4c7.4,3,13.7,7.7,19,14.1     c5.2,6.5,9.2,14.9,11.9,25.2c2.7,10.4,4,22.9,4,37.5v141h-47v-141.2c0-10.9-1.2-19.3-3.5-25.3c-2.4-6-5.7-10.1-10.1-12.4     c-4.4-2.3-9.7-3.4-16-3.4c-5.4,0-10.1,1.4-14.2,4.1c-4.1,2.8-7.6,6.6-10.4,11.5c-2.8,4.9-4.9,10.5-6.4,16.7     C1908.9,1788.1,1908.2,1794.9,1908.2,1802.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M2134.6,1935.8c-14.1,0-26.7-2.1-37.7-6.4c-11-4.2-20.4-10.5-28-18.9c-7.7-8.3-13.5-18.7-17.5-31.1     c-4-12.4-6-26.7-6-43v-21c0-18.3,2.1-34.1,6.4-47.6c4.2-13.4,10.1-24.5,17.6-33.1c7.5-8.6,16.4-15,26.7-19.2     c10.3-4.2,21.4-6.3,33.4-6.3c13.8,0,25.8,2.3,35.9,6.8c10.1,4.5,18.4,11.2,24.9,20c6.5,8.8,11.4,19.7,14.5,32.7     c3.2,13,4.7,28,4.7,45.1v23.8h-141.6v-35.7h95.2v-5c-0.3-9.9-1.5-18.5-3.6-25.7c-2.2-7.2-5.6-12.7-10.3-16.5     c-4.7-3.8-11.3-5.7-19.8-5.7c-6,0-11.4,1.1-16.1,3.4c-4.7,2.3-8.6,6-11.6,11.1c-3,5.1-5.3,11.9-7,20.5     c-1.6,8.5-2.4,19.1-2.4,31.6v21c0,10.9,1,20.1,2.9,27.6c1.9,7.5,4.9,13.7,8.8,18.5c3.9,4.8,8.6,8.3,14.2,10.5     c5.6,2.2,12.1,3.3,19.5,3.3c10.8,0,20.1-2,28-6.1c7.9-4.1,14.8-9.4,20.6-16l21,28.8c-4,5.2-9.3,10.4-15.8,15.4     c-6.5,5-14.5,9.2-23.8,12.4C2158.2,1934.2,2147.2,1935.8,2134.6,1935.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M2320.5,1713.6v36.3h-107.1v-36.3H2320.5z M2242.7,1660.1h47v210.7c0,6.6,0.7,11.7,2.2,15.2     c1.5,3.6,3.5,5.9,6.1,7.2c2.6,1.2,5.7,1.8,9.4,1.8c2.7,0,5.3-0.2,8-0.6c2.6-0.4,4.5-0.8,5.7-1.2l-0.2,37.7     c-3.5,1.3-7.5,2.5-11.9,3.4c-4.4,0.9-9.9,1.4-16.5,1.4c-9.7,0-18.2-2-25.6-5.9c-7.4-4-13.3-10.5-17.6-19.6     c-4.4-9.1-6.6-21.1-6.6-36.2V1660.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M2447.4,1678.5l-71,253.3h-51.2l93.2-293.6h32.1L2447.4,1678.5z M2505.3,1822.7v41.1h-136.7v-41.1H2505.3z      M2504.1,1931.8l-71.2-253.3l-3.2-40.3h32.3l93.6,293.6H2504.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M2625.6,1638.2v293.6h-49v-293.6H2625.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M2710.5,1760.2v171.6h-47.2v-218.2h44.2L2710.5,1760.2z M2701.9,1814.8h-14.9c-0.1-15.6,1.5-29.9,5-42.9     c3.5-13,8.5-24.1,14.9-33.4s14.2-16.4,23.3-21.5c9.1-5,19.2-7.6,30.3-7.6c8.7,0,16.7,1.4,23.8,4.3c7.1,2.9,13.2,7.6,18.3,14     c5.1,6.5,9,14.9,11.8,25.2c2.8,10.4,4.1,23,4.1,37.9v140.8h-47v-141c0-10.3-1.1-18.6-3.2-24.6c-2.2-6.1-5.4-10.4-9.7-12.9     c-4.3-2.6-9.8-3.8-16.5-3.8c-5.9,0-11.4,1.7-16.4,5.1c-5,3.4-9.3,8.1-12.9,14.1c-3.6,6-6.3,12.9-8.3,20.8     C2702.6,1797.4,2701.7,1805.8,2701.9,1814.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M2952.2,1874.3c0-4.6-1.3-8.6-3.9-12.2c-2.6-3.6-6.8-7.1-12.6-10.5c-5.8-3.4-13.5-7.2-23.2-11.4     c-9.9-4.2-18.9-8.3-26.7-12.5c-7.9-4.2-14.5-8.8-19.9-13.8c-5.4-5-9.4-10.9-12.2-17.4c-2.8-6.6-4.1-14.2-4.1-22.8     c0-9,1.7-17.4,5-25.1c3.4-7.7,8.2-14.5,14.4-20.3c6.3-5.8,13.8-10.4,22.8-13.7c8.9-3.4,18.9-5,29.9-5c15.7,0,29.2,2.9,40.4,8.7     c11.2,5.8,19.8,13.7,25.8,23.8c6,10.1,9,21.7,9,34.9h-47c0-5.4-1-10.4-3-14.9c-2-4.6-5.1-8.2-9.3-11c-4.2-2.8-9.5-4.1-15.9-4.1     c-5.9,0-10.9,1.1-14.8,3.3c-4,2.2-6.9,5.1-8.9,8.8c-2,3.6-2.9,7.8-2.9,12.5c0,3.4,0.6,6.3,1.8,8.9c1.2,2.6,3.2,5,6,7.3     c2.8,2.3,6.6,4.7,11.4,7.2c4.8,2.5,10.9,5.3,18.2,8.4c14.7,5.5,26.9,11.3,36.6,17.4c9.7,6.1,17,13.2,21.8,21.3     c4.8,8.1,7.2,18.1,7.2,30c0,9.7-1.7,18.4-5.2,26.2c-3.5,7.8-8.6,14.5-15.3,20.2c-6.7,5.6-14.8,10-24.1,13     c-9.3,3-19.7,4.5-31.2,4.5c-17.1,0-31.5-3.4-43.3-10.2c-11.8-6.8-20.7-15.6-26.7-26.3c-6.1-10.8-9.1-22.1-9.1-34.1h45.4     c0.5,8.6,2.4,15.3,5.6,20.1c3.2,4.8,7.4,8.1,12.5,10.1c5.1,1.9,10.4,2.9,15.9,2.9c6.6,0,12-0.9,16.3-2.8c4.3-1.9,7.6-4.7,9.8-8.4     C2951.1,1883.4,2952.2,1879.1,2952.2,1874.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M3074.4,1713.6v218.2h-47.2v-218.2H3074.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M3102.9,1831.5v-17.1c0-17.9,1.7-33.4,5-46.5c3.4-13.1,8.2-24,14.5-32.8c6.3-8.7,14-15.2,23.1-19.4     c9.1-4.2,19.3-6.3,30.8-6.3c11.7,0,21.6,2.4,29.6,7.3c8.1,4.8,14.7,11.8,20,20.8c5.2,9,9.3,19.8,12.3,32.3     c3,12.5,5.1,26.4,6.5,41.7v23.8c-1.3,14.8-3.6,28.3-6.9,40.6c-3.2,12.3-7.6,22.9-13.1,31.9c-5.5,8.9-12.2,15.8-20.2,20.7     c-7.9,4.8-17.5,7.3-28.6,7.3c-11.2,0-21.2-2.2-30.2-6.7c-9-4.4-16.7-11-23.1-19.8c-6.4-8.7-11.3-19.6-14.6-32.6     C3104.6,1863.8,3102.9,1848.8,3102.9,1831.5z M3226.2,1713.6h42.8v219c0,19.6-3.6,35.7-10.8,48.3c-7.2,12.6-17.2,21.9-29.9,27.9     c-12.8,6-27.6,9.1-44.4,9.1c-6.2,0-13.5-1-21.9-2.9c-8.4-1.9-16.7-4.9-24.9-8.9c-8.2-4-14.9-8.8-20-14.6l16.9-32.7     c6.3,6.6,13.8,11.6,22.4,15.1c8.6,3.5,16.9,5.2,24.8,5.2c8.6,0,15.9-1.4,22-4.3c6-2.9,10.7-7.7,13.8-14.3     c3.2-6.7,4.7-15.6,4.7-26.9v-170.4L3226.2,1713.6z M3150.1,1814.4v17.1c0,11.2,0.7,20.8,2.2,28.8c1.5,8.1,3.8,14.7,6.9,19.9     c3.1,5.2,7.2,9,12.2,11.5c5,2.5,11,3.7,17.8,3.7c9,0,16.3-2.1,21.8-6.5c5.5-4.3,9.7-10.1,12.7-17.4c3-7.3,5.1-15.6,6.5-24.7     v-46.8c-0.7-7.1-2-13.7-4-19.9c-2-6.1-4.6-11.5-7.9-16.1c-3.2-4.6-7.2-8.2-12-10.8c-4.8-2.6-10.3-3.8-16.6-3.8     c-6.9,0-12.8,1.3-17.8,3.9c-5,2.6-9.1,6.6-12.3,11.8c-3.2,5.2-5.5,12-7.1,20.2C3150.9,1793.6,3150.1,1803.2,3150.1,1814.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M3347.8,1622v309.7H3301V1622H3347.8z M3339.5,1814.8h-14.9c-0.1-15.2,1.5-29.2,4.8-41.9     c3.4-12.8,8.2-23.9,14.5-33.5c6.3-9.5,13.9-16.9,22.9-22.1c8.9-5.2,18.9-7.8,29.7-7.8c9,0,17.1,1.5,24.4,4.5     c7.3,3,13.6,7.8,19,14.2c5.4,6.5,9.4,14.9,12.2,25.4c2.8,10.5,4.1,23.2,4.1,38.1v139.9h-47v-140.4c0-10.4-1.1-18.6-3.2-24.7     c-2.2-6.1-5.4-10.5-9.8-13.2c-4.4-2.7-9.8-4-16.2-4s-12.2,1.7-17.2,5.1c-5,3.4-9.3,8.1-12.8,14.1c-3.5,6-6.1,12.9-7.9,20.8     C3340.4,1797.4,3339.5,1805.8,3339.5,1814.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M3576.8,1713.6v36.3h-107.1v-36.3H3576.8z M3498.9,1660.1h47v210.7c0,6.6,0.7,11.7,2.2,15.2     c1.5,3.6,3.5,5.9,6.1,7.2c2.6,1.2,5.7,1.8,9.4,1.8c2.7,0,5.3-0.2,8-0.6c2.6-0.4,4.5-0.8,5.7-1.2l-0.2,37.7     c-3.5,1.3-7.5,2.5-11.9,3.4c-4.4,0.9-9.9,1.4-16.5,1.4c-9.7,0-18.2-2-25.6-5.9c-7.4-4-13.3-10.5-17.6-19.6     c-4.4-9.1-6.6-21.1-6.6-36.2V1660.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M3699.6,1874.3c0-4.6-1.3-8.6-3.9-12.2c-2.6-3.6-6.8-7.1-12.6-10.5c-5.8-3.4-13.5-7.2-23.2-11.4     c-9.9-4.2-18.9-8.3-26.7-12.5c-7.9-4.2-14.5-8.8-19.9-13.8c-5.4-5-9.4-10.9-12.2-17.4c-2.8-6.6-4.1-14.2-4.1-22.8     c0-9,1.7-17.4,5-25.1c3.4-7.7,8.2-14.5,14.4-20.3c6.3-5.8,13.8-10.4,22.8-13.7c8.9-3.4,18.9-5,29.9-5c15.7,0,29.2,2.9,40.4,8.7     c11.2,5.8,19.8,13.7,25.8,23.8c6,10.1,9,21.7,9,34.9h-47c0-5.4-1-10.4-3-14.9c-2-4.6-5.1-8.2-9.3-11c-4.2-2.8-9.5-4.1-15.9-4.1     c-5.9,0-10.9,1.1-14.8,3.3c-4,2.2-6.9,5.1-8.9,8.8c-2,3.6-2.9,7.8-2.9,12.5c0,3.4,0.6,6.3,1.8,8.9c1.2,2.6,3.2,5,6,7.3     c2.8,2.3,6.6,4.7,11.4,7.2c4.8,2.5,10.9,5.3,18.2,8.4c14.7,5.5,26.9,11.3,36.6,17.4c9.7,6.1,17,13.2,21.8,21.3     c4.8,8.1,7.2,18.1,7.2,30c0,9.7-1.7,18.4-5.2,26.2c-3.5,7.8-8.6,14.5-15.3,20.2c-6.7,5.6-14.8,10-24.1,13     c-9.3,3-19.7,4.5-31.2,4.5c-17.1,0-31.5-3.4-43.3-10.2c-11.8-6.8-20.7-15.6-26.7-26.3c-6.1-10.8-9.1-22.1-9.1-34.1h45.4     c0.5,8.6,2.4,15.3,5.6,20.1c3.2,4.8,7.4,8.1,12.5,10.1c5.1,1.9,10.4,2.9,15.9,2.9c6.6,0,12-0.9,16.3-2.8c4.3-1.9,7.6-4.7,9.8-8.4     C3698.5,1883.4,3699.6,1879.1,3699.6,1874.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M3025,1656.5c0-7.7,2.3-14,6.9-19c4.6-5,11-7.5,19.4-7.5c8.2,0,14.6,2.5,19.1,7.5c4.5,5,6.8,11.3,6.8,19    c0,7.4-2.3,13.5-6.8,18.5c-4.5,4.9-10.9,7.4-19.1,7.4c-8.3,0-14.8-2.5-19.4-7.4C3027.3,1670.1,3025,1663.9,3025,1656.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M3755.2,1631.8h-13v-9.2h37.3v9.2h-13.2v39.3h-11V1631.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M3826.1,1652.5c-0.2-5.8-0.4-12.9-0.4-19.9h-0.2c-1.5,6.2-3.5,13.1-5.4,18.8l-5.9,18.9h-8.6l-5.2-18.8   c-1.6-5.7-3.2-12.6-4.4-18.9h-0.1c-0.3,6.6-0.5,14-0.9,20.1l-0.9,18.4H3784l3.1-48.5h14.6l4.8,16.2c1.5,5.6,3,11.7,4.1,17.4h0.2   c1.4-5.6,3-12,4.6-17.4l5.2-16.1h14.3l2.7,48.5h-10.7L3826.1,1652.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPrimary);
export default __webpack_public_path__ + "static/media/logo-primary.20a86fc7ac2c66682d5bb5f95157b67b.svg";
export { ForwardRef as ReactComponent };